import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { ScrollToTop } from "@utils/ScrollToTop";

import App from "./App";

import "./index.css";
import "./i18n";

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  rootElement.innerHTML = "";
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>,
);
